var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'ネットがなくても歩数計測できますか？'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          ネットワークがなくても歩数計測できます。WeRUNはバックグラウンドで実行し、計測した歩数を携帯に保存しています。ネットワークに接続した場合、ホームを下スワイプすれば歩数データを手動で同期できます。\n        ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73bfbe66","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help6.vue
// module id = 841S
// module chunks = 0